export enum WhoIsAtFault {
  Both = 'both',
  ThirdParty = 'third-party',
  FirstParty = 'first-party',
  Unknown = 'unknown',
}
